import { Navigate } from "react-router-dom";
import useAuthStore from "../store/useAuthStore";

interface PropsTypes {
  component: React.ComponentType<any>;
  redirectTo: string;
  extraProps?: any;
}

export const RestrictedRoute: React.FC<PropsTypes> = ({
  component: Component,
  redirectTo = "/",
  extraProps = {},
}) => {
  const { user } = useAuthStore();

  if (user?.isLoggedIn) {
    return <Navigate to={redirectTo} />;
  } else {
    return <Component {...extraProps} />;
  }
};
